import { render, staticRenderFns } from "./BargainDetail.vue?vue&type=template&id=63fa5de9&scoped=true&"
import script from "./BargainDetail.vue?vue&type=script&lang=js&"
export * from "./BargainDetail.vue?vue&type=script&lang=js&"
import style0 from "./BargainDetail.vue?vue&type=style&index=0&id=63fa5de9&prod&lang=scss&scoped=true&"
import style1 from "./BargainDetail.vue?vue&type=style&index=1&id=63fa5de9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa5de9",
  null
  
)

export default component.exports